import React from "react";
import { motion } from "framer-motion";
import { Thermometer, Gauge, Eclipse, Droplets, Waves } from "lucide-react";

function Bar({ label, value, display, color, testid }) {
  return (
    <div className="mb-2.5" data-testid={testid}>
      <div className="flex justify-between items-baseline mb-1">
        <span className="telem-label">{label}</span>
        <span className="font-mono text-sm text-white">{display}</span>
      </div>
      <div className="telem-track">
        <div className="telem-fill" style={{ width: `${Math.max(2, Math.min(100, value))}%`, background: color }} />
      </div>
    </div>
  );
}

export default function RadiometricMoonHUD({ sim }) {
  const rayleigh = (16 + sim.coverage * 22).toFixed(1);
  return (
    <motion.div
      data-testid="radiometric-moon-hud"
      initial={{ opacity: 0, x: 24 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.7, delay: 0.15 }}
      className="hud-panel w-[280px] sm:w-[300px]"
    >
      <div className="hud-head">
        <span className="hud-kicker">Radiometric Telemetry</span>
        <span className="live-dot" />
      </div>

      <div className="grid grid-cols-2 gap-2 mb-3">
        <div className="bio-metric" data-testid="radio-temp">
          <div className="flex items-center gap-1.5 text-slate-400"><Thermometer size={13} className="text-orange-400" /><span className="telem-label">Regolith Temp</span></div>
          <div className="font-mono text-lg font-bold text-white mt-1">{sim.surfaceTemp.toFixed(0)}<span className="text-[10px] text-slate-500 ml-0.5">°C</span></div>
        </div>
        <div className="bio-metric" data-testid="radio-velocity">
          <div className="flex items-center gap-1.5 text-slate-400"><Gauge size={13} className="text-sky-400" /><span className="telem-label">Orbital V</span></div>
          <div className="font-mono text-lg font-bold text-white mt-1">{sim.orbitalVelocity.toFixed(3)}<span className="text-[10px] text-slate-500 ml-0.5">km/s</span></div>
        </div>
      </div>

      <Bar label="Umbral Depth" value={sim.umbralDepth} display={`${sim.umbralDepth.toFixed(1)} %`} color="#ff6b4a" testid="radio-umbral-depth" />
      <Bar label="Danjon Luminance" value={sim.danjonLum * 400} display={`L = ${sim.danjon.toFixed(1)}`} color={`rgb(${sim.danjonRgb.map((c) => Math.round(c * 255)).join(",")})`} testid="radio-danjon" />
      <Bar label="Rayleigh Refraction ∠" value={(rayleigh / 40) * 100} display={`${rayleigh}°`} color="#38bdf8" testid="radio-rayleigh" />

      <div className="flex items-center gap-2 mt-3 pt-2.5 border-t border-white/5">
        <Eclipse size={14} className="text-orange-400" />
        <span className="text-[10px] text-slate-400">Peak coverage</span>
        <span className="font-mono text-sm text-orange-300 ml-auto font-bold">{(sim.coverage * 100).toFixed(1)}%</span>
      </div>
    </motion.div>
  );
}
